import React from 'react'
import ReactDOM from 'react-dom/client'
import i18n from './i18n'
import {I18nextProvider} from 'react-i18next'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'


window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault() // Prevents the default browser install prompt
    // Store the event for later use
    window.deferredPrompt = event
})


const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <I18nextProvider i18n={i18n}>
        <React.StrictMode>
            <App/>
        </React.StrictMode>
    </I18nextProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
